import React from 'react';
import Icon from './Icon';

export default function ActionIcon(props) {
  return <Icon className="hover-blue" {...props} />;
}
